<template>
  <div :class="['app-container']">
    <global-header
      mode="light"
      :title="title"
      :showBack="showBack"
      background="#48d5af"
    />
    <router-view ref="child" />
    <base-service />
  </div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader";
import BaseService from "@/components/BaseService";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ServiceLayout",
  components: { GlobalHeader, BaseService },
  data() {
    return {
      showBack: false
    };
  },
  computed: {
    ...mapGetters(["gameName", "title"])
  },
  methods: {
    ...mapActions(["SetTitle"]),
    resetAppealSumbit() {
      this.$refs.child.resetData();
    }
  },
  watch: {
    "$route.path": {
      handler: function(val) {
        if (
          val.indexOf("appealSubmit") != -1 ||
          val.indexOf("appealFind") != -1 ||
          val.indexOf("tel") != -1
        ) {
          this.showBack = false;
        } else {
          this.showBack = true;
        }
        let titleName = "";
        this.$nextTick(() => {
          const { parent, title } = this.$route.meta;
          titleName =
            this.gameName && parent ? `${this.gameName} · ${title}` : title;
          this.SetTitle(titleName);
        });
      },
      immediate: true,
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$ls.remove("footerIndex");
    next();
  }
};
</script>

<style module lang="less"></style>
